import { View } from 'react-native';

export function ConfigContainer({ children }: { children: React.ReactNode }): JSX.Element {
  return <View className="z-[-1]">{children}</View>;
}
